// Mirrors the n8n dispatch policy. The browser displays it; dispatchers enforce it.
export function getRemainingCooldownSeconds(status, now = Date.now()) {
  if (!status || status.success === false) return null
  if (!status.last_dispatch_at) return 0
  const lastDispatch = Date.parse(status.last_dispatch_at)
  if (!Number.isFinite(lastDispatch)) return null
  const durationMs = (status.pharmacist_type === 'freelance' ? 3 : 5) * 60 * 1000
  return Math.max(0, Math.ceil((lastDispatch + durationMs - now) / 1000))
}

export function formatCooldown(seconds) {
  return `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`
}
